import { useState, useRef } from 'react';
import { useDispatch } from 'react-redux';

import { handleImageError } from '../../Utils/helpers';

import profileimage from '../../Static/icons/user.svg';

import { StyledAboutWrapper } from '../About/StyledAbout';
import {
  StyledProfileWrapper,
  StyledAvatarWrapper,
  StyledControlsWrapper,
} from './StyledProfile';

import { Form } from '../UI/Form';
import { MoreButton } from '../UI/Buttons';

import { rx } from '../../Redux/Actions/';

import { authRx, authMediaRx } from '../../Redux/Actions/UserActions/thunk.js';

import { updateUser, updateAvatar } from '../../API/User';

import { constants } from '../../Configs/constants';

const { BASE_URL } = constants;

export const Profile = ({
  avatarURL,
  gravatar,
  formdata,
  userData,
  userId,
  setUserAction,
  config = null,
  controls = [],
}) => {
  const avatarInput = useRef(null);
  const imageRef = useRef(null);
  const { tokenAccess, tokenRefresh } = userData;
  const [active, setActive] = useState(false);
  const dispatch = useDispatch();

  const handleUpdateUser = result => {
    dispatch(setUserAction(result.data.user));
    handleSetActive(false);
  };

  const handleUpdateAvatar = result => {
    dispatch(setUserAction(result.data.user));
  };

  const handleSubmit = (e, data) => {
    const body = JSON.stringify(data);
    e.preventDefault();
    dispatch(
      rx(authRx, handleUpdateUser, updateUser, tokenAccess, tokenRefresh, {
        body,
        id: userId,
      }),
    );
  };

  const handleSubmitAvatar = data => {
    const body = new FormData();
    body.append('avatarURL', data);
    dispatch(
      rx(authMediaRx, handleUpdateAvatar, updateAvatar, tokenRefresh, {
        body,
        id: userId,
        content: 'multipart/form-data',
      }),
    );
  };

  const handleClickAvatar = e => {
    avatarInput.current.click();
  };

  const handleChangeAvatar = e => {
    if (e.target.files[0] && e.target.files[0].type.includes('image')) {
      const fileReader = new FileReader();

      fileReader.onload = () => {
        handleSubmitAvatar(e.target.files[0]);
        imageRef.current.src = fileReader.result;
      };

      fileReader.readAsDataURL(e.target.files[0]);
    }
  };

  const handleSetActive = value => {
    setActive(value);
  };

  return (
    <StyledAboutWrapper>
      <h2>Profilis</h2>
      <StyledProfileWrapper>
        {!!controls.length && (
          <StyledControlsWrapper>
            {controls.map((control, i) => {
              return (
                <li key={i}>
                  <MoreButton {...control} />
                </li>
              );
            })}
          </StyledControlsWrapper>
        )}
        <StyledAvatarWrapper onClick={handleClickAvatar}>
          <picture className="card__photo">
            {!!avatarURL && (
              <>
                <source
                  srcSet={`${BASE_URL}/${avatarURL}.webp`}
                  type="image/webp"
                />
                <source
                  srcSet={`${BASE_URL}/${avatarURL}.png`}
                  type="image/png"
                />
              </>
            )}
            <img
              src={gravatar}
              alt={formdata.name}
              width="140"
              height="160"
              ref={imageRef}
              onError={handleImageError(profileimage)}
            />
          </picture>
        </StyledAvatarWrapper>
        <input
          type="file"
          accept="image/jpeg,image/png,image/gif,image/tiff,image/bmp"
          style={{ display: 'none' }}
          ref={avatarInput}
          onChange={handleChangeAvatar}
        />
        <Form
          entered={true}
          {...config}
          formdata={formdata}
          submitFn={handleSubmit}
          active={active}
          allowPatch={true}
          setActivated={handleSetActive}
        />
      </StyledProfileWrapper>
    </StyledAboutWrapper>
  );
};
